import axios from '../../axios'
import { addZhiniaoPrefix } from '@utils/SSOHelper'

export default {
  /* 主播-我的直播列表 */
  queryLiveList: (pageNumber: number) => {
    return axios.get(addZhiniaoPrefix('/learn/app/clientapi/live/school/queryLiveSchoolMyRooms.do'), {
      params: {
        curPage: pageNumber,
        numPerPage: 30,
        type: '1', // 1展示直播中和未开始直播
      },
    })
  },
  /* 主播实名认证判断 */
  anchorVerify: () => {
    return axios.get(addZhiniaoPrefix('/learn/app/clientapi/user/verify/getUserRealNameVerifyStatus.do'), {})
  },
}
